import plugin from 'tailwindcss/plugin';

const textBorder = plugin.withOptions(function () {
	return function ({ addComponents, e, theme }) {
		addComponents({
			[`.${e('text-shadow')}`]: {
				'text-shadow': `0px 0px 6px ${theme('colors.black')}`,
			},
		});
	};
});

export default textBorder;
